export interface PagedList<T> {
    indexFrom?: number;
    pageIndex?: number;
    pageSize?: number;
    totalCount: number;
    totalPages?: number;
    items: T[];
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export function normalizePagedList<T>(data: unknown): PagedList<T> {
    const d = (data ?? {}) as Record<string, unknown>;
    return {
        indexFrom: (d.indexFrom ?? d.IndexFrom) as number | undefined,
        pageIndex: (d.pageIndex ?? d.PageIndex) as number | undefined,
        pageSize: (d.pageSize ?? d.PageSize) as number | undefined,
        totalCount: Number(d.totalCount ?? d.TotalCount ?? 0),
        totalPages: (d.totalPages ?? d.TotalPages) as number | undefined,
        items: ((d.items ?? d.Items ?? []) as T[]) ?? [],
        hasPreviousPage: (d.hasPreviousPage ?? d.HasPreviousPage) as boolean | undefined,
        hasNextPage: (d.hasNextPage ?? d.HasNextPage) as boolean | undefined,
    };
}
